import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../../shared/components/Link';
import styles from './AreaItem.scss';

const AreaItem = ({ areaItemClassName, title, description, image, href, trackClick }) =>
  (
    <Link
      className={areaItemClassName}
      href={href}
      onClick={trackClick}
    >
      <div className={styles.imageWrapper}>
        <picture>
          <source type="image/webp" srcSet={`${image}.webp?v=4`} />
          <img
            className={styles.image}
            src={`${image}.jpg?v=4`}
            alt={title}
          />
        </picture>
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </Link>
  );
AreaItem.propTypes = {
  areaItemClassName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  trackClick: PropTypes.func.isRequired,
};

export default AreaItem;
